import { createFileRoute } from '@tanstack/react-router';
import { getRamalamaCopy } from '@/components/ramalama/ramalama-copy';
import {
  RAMALAMA_OG_IMAGE,
  RAMALAMA_PATH,
} from '@/components/ramalama/ramalama-json-ld';
import { RamalamaPage } from '@/components/ramalama/ramalama-page';
import { isCurrentLocaleIndexablePath } from '@/lib/locale';
import { seo } from '@/lib/seo';
import { getImageUrl } from '@/lib/urls';

export const Route = createFileRoute('/ramalama-trend')({
  head: () => {
    const copy = getRamalamaCopy();
    const metadata = seo(RAMALAMA_PATH, {
      title: copy.seoTitle,
      description: copy.seoDescription,
      keywords: copy.keywords.join(', '),
      image: getImageUrl(RAMALAMA_OG_IMAGE),
    });
    // Untranslated locales keep the `noindex` from `seo()`.
    if (!isCurrentLocaleIndexablePath(RAMALAMA_PATH)) return metadata;
    return {
      ...metadata,
      meta: [
        ...metadata.meta,
        { name: 'robots', content: 'index, follow, max-image-preview:large' },
      ],
    };
  },
  component: RamalamaPage,
});
